import { DeleteIcon, SearchIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Heading,
  Tr,
  useColorModeValue,
  useToast,
  useDisclosure,
  Checkbox,
  SimpleGrid,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  ModalFooter,
  Center,
  Radio,
  Stack,
  RadioGroup,
  SkeletonText,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import Default from 'components/fields/InputField';
import { useRef, useState, useCallback, useEffect, memo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { HSeparator } from 'components/separator/Separator';
import InterfaceSelect from 'components/select';
// import { useParams } from 'react-router-dom';
import TableSkeleton from './components/tableSkeleton';
import AssetParamDialog from './modal/assetParam';
import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';
import { useLocation, useNavigate } from 'react-router-dom';
import GlobalAlertDialog from 'components/GlobalAlertDialog';
import GlobalModal from 'components/GlobalModal';
import {
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
} from '@chakra-ui/icons';
import { version } from 'jszip';
import ComplexTable from 'views/admin/default/components/ComplexTable';
import Cookies from 'js-cookie';
import ClusterModal from 'components/ClusterModal';
import { sortDevices } from 'views/hooks/sortDevices';

export default function Configure() {
  const userAuthority = localStorage.getItem('userAuthority');
  const customerId = localStorage.getItem('customerId');
  const isTenantAdmin = userAuthority === 'TENANT_ADMIN';
  const toast = useToast();
  const location = useLocation();
  const [gridxType, setGridxType] = useState('');
  const navigate = useNavigate();
  // const devicesArray = location.state?.devicesArray;
  const cardBg = useColorModeValue('white', 'navy.700');
  const textColor = useColorModeValue('navy.700', 'white');
  const inputBg = useColorModeValue('white', 'navy.600');
  // const skeletonBg = useColorModeValue('navy.50', 'navy.100');
  const [configName, setConfigName] = useState('');
  const [configId, setConfigId] = useState(null);
  // const { deviceUUID } = useParams();
  const deviceId = localStorage.getItem('deviceId');
  const isFirstRender = useRef(true);
  const [selectedDevices, setSelectedDevices] = useState([deviceId]);
  const [serialNumber, setSerialNumber] = useState('');
  const {
    isOpen: isOpenSaveConf,
    onOpen: DeviceSaveConf,
    onClose: onCloseSaveConf,
  } = useDisclosure();
  const platformId = process.env.REACT_APP_PLATFORM_ID;
  const groupID = localStorage.getItem('groupID');
  const onOpenSaveConf = () => {
    setSelectedDevices(
      preselectedDevices.length > 0
        ? Array.from(new Set([...preselectedDevices, deviceId]))
        : [deviceId],
    );
    setSearchType('deviceId');
    setSelectedCluster('');
    setStateOptions([]);
    setSelectedState('');
    setNocOptions([]);
    setSelectedNoc('');
    setPlantOptions([]);
    setSelectedPlant('');
    setDevicesArray([]);
    setSerialNumber('');
    setCurrentPage(-1);
    DeviceSaveConf();
    fetchAllDevices('', true, 0);
  };
  const [configurations, setConfigurations] = useState([]);
  // const [slavesToDelete, setSlavesToDelete] = useState([]);
  const [originalData, setOriginalData] = useState({});
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openAssetMastermodel, setAssetMasterOpen] = useState(false);
  const [currentSlaveId, setCurrentSlaveId] = useState(null);
  const [deviceType, setDeviceType] = useState(1);
  const [maxSlavePerDevice, setMaxSlavePerDevice] = useState(1);
  const [maxSlavePerInterFace, setMaxSlavePerInterFace] = useState(1);
  const [maxSlaveParameters, setMaxSlaveParameters] = useState(1);
  // const [modbusConfigVersion, setModbusConfigVersion] = useState(1);
  const [loadingDevices, setLoadingDevices] = useState(false);
  const [devicesArray, setDevicesArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(-1);
  const [hasNext, setHasNext] = useState(false);
  const [interfaceList, setInterfaceList] = useState([]);
  // Add a new state to store interface settings by interface_id
  const [interfaceSettingsMap, setInterfaceSettingsMap] = useState({});
  const [searchType, setSearchType] = useState('deviceId');
  const [clusterOptions, setClusterOptions] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState('');
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [nocOptions, setNocOptions] = useState([]);
  const [selectedNoc, setSelectedNoc] = useState('');
  const [plantOptions, setPlantOptions] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState('');
  const [configDeviceMap, setConfigDeviceMap] = useState({});

  const closeAssetParameterModal = () => {
    setAssetMasterOpen(false);
  };

  const fetchAllDevices = useCallback(
    async (serialNumber = '', setLoading = true, page = 0) => {
      setLoadingDevices(setLoading);

      let apiUrl = apiUrls.allDevices(serialNumber, page);

      const resp = await axiosInstance.get(apiUrl);
      const devices = resp.data.data;
      setHasNext(resp.data.hasNext);

      const devicesNameIdMap = sortDevices(devices.map((d) => d.name)).map(
        (name) => ({
          id: name,
          name,
        }),
      );

      if (serialNumber || page === 0) {
        // setDevicesArray((prev) => {
        //   const selected = prev.filter((d) => selectedDevices.includes(d.id));

        //   const newDevices = devicesNameIdMap.filter(
        //     (d) => !selectedDevices.includes(d.id),
        //   );

        //   return [...selected, ...newDevices];
        // });
        setDevicesArray(devicesNameIdMap);
      } else {
        const newDevices = devicesNameIdMap.filter((d) => {
          if (deviceId !== d.id) {
            return !selectedDevices.includes(d.id);
          } else {
            return true;
          }
        });
        setDevicesArray((prev) => [...prev, ...newDevices]);
      }

      setLoadingDevices(false);
    },
    [deviceId],
  );

  const fetchModbusConfigswithDevices = () => {
    const keys = 'modbus_configs';
    setLoadingDevices(true);
    axiosInstance
      .get(apiUrls.fetchModbusConfigsandpatches(platformId, groupID, keys))
      .then((res) => {
        const configs = res.data.modbus_configs || [];
        const map = {};
        configs.forEach((cfg) => {
          // Map to array of device IDs, not array of objects
          map[cfg.id] = (cfg.devices || []).map((d) => d.device_id);
        });
        setConfigDeviceMap(map);
        console.log('Configsss-----', configs);
      });
  };

  useEffect(() => {
    fetchModbusConfigswithDevices();
  }, [platformId, groupID]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (serialNumber) {
      setCurrentPage(0);
    }

    if (currentPage === -1) return;

    if (searchType === 'deviceId') {
      fetchAllDevices(serialNumber, true, currentPage);
    }
  }, [currentPage, serialNumber, fetchAllDevices, searchType]);

  const isSlaveChanged = (slave) => {
    const original = originalData[slave.id];
    return JSON.stringify(slave) !== JSON.stringify(original);
  };

  const writeFunctionCodes = {
    'Read Only': -1,
    'Write Coil': 5,
    '6 Label': 6,
    '16 Label': 16,
  };

  const ParamTypes = {
    '32bit float': 3,
    '32bit uint': 2,
    '32bit int': 18,
    Str: 42,
    '16bit float': 26,
    '16bit int': 14,
    '16bit uint': 1,
    Bool: 43,
  };

  const RegisterDataType = {
    DCBA: 1,
    BADC: 3,
    Bool: 2,
  };

  const Actions = {
    'Read Only': 0,
    'Read Write': 1,
  };
  const writeFunctionCodesReverse = Object.fromEntries(
    Object.entries(writeFunctionCodes).map(([k, v]) => [v, k]),
  );
  const ParamTypesReverse = Object.fromEntries(
    Object.entries(ParamTypes).map(([k, v]) => [v, k]),
  );
  const RegisterDataTypeReverse = Object.fromEntries(
    Object.entries(RegisterDataType).map(([k, v]) => [v, k]),
  );
  const ActionsReverse = Object.fromEntries(
    Object.entries(Actions).map(([k, v]) => [v, k]),
  );

  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [interfaceIdMap, setInterfaceIdMap] = useState({});
  const [modbusConfigMap, setmodbusConfigMap] = useState({});
  const [interfaceNumberMap, setInterfaceNumberMap] = useState({});
  const [selectedModbusConfigId, setSelectedModbusConfigId] = useState(() => {
    // Try to load from localStorage first

    return localStorage.getItem('selectedModbusConfigId') || '';
  });
  // const errorCancelRef = useRef();
  const preselectedDevices = configDeviceMap[selectedModbusConfigId] || [];

  const showError = (message) => {
    setErrorMessage(message);
    setIsErrorOpen(true);
  };

  const confirmDelete = (type, slaveId, paramId = null) => {
    setDeleteTarget({ type, slaveId, paramId });
    setIsDeleteOpen(true);
  };

  const defaultParameter = {
    id: uuidv4(),
    name: '',
    fn_code: 3,
    address: 0,
    type: 43,
    factor: 1,
    register_count: 1,
    register_data_type: 1,
    offset: 0,
    write_fn_code: -1,
    access: 0,
  };

  const handleDeleteConfirmed = () => {
    if (deleteTarget.type === 'slave') {
      setConfigurations((prev) =>
        prev.filter((slave) => slave.id !== deleteTarget.slaveId),
      );
    } else if (deleteTarget.type === 'parameter') {
      setConfigurations((prev) =>
        prev.map((slave) => {
          if (slave.id !== deleteTarget.slaveId) return slave;
          // Remove parameter, do NOT increment version here
          return {
            ...slave,
            parameters: slave.parameters.filter(
              (param) => param.id !== deleteTarget.paramId,
            ),
          };
        }),
      );
    }
    setIsDeleteOpen(false);
    setDeleteTarget({ type: null, slaveId: null, paramId: null });
  };

  const fetchInterfaces = useCallback(async () => {
    try {
      const keys = 'interfaces,modbus_configs';
      const resp = await axiosInstance.get(
        apiUrls.groupAttributes(deviceId, keys),
      );
      const attrMap = Object.fromEntries(
        resp.data.map((a) => [a.key, a.value]),
      );

      setInterfaceList(attrMap.interfaces || []);

      const settingsMap = {};
      (attrMap.interfaces || []).forEach((iface) => {
        // iface.interface is the interface_id
        if (iface.interface) {
          settingsMap[iface.interface] = iface.settings || {};
        }
      });
      setInterfaceSettingsMap(settingsMap);

      const modbusConfigMap = attrMap.modbus_configs.reduce((acc, i) => {
        const id = i.id || '';
        const name = i.name || '';
        acc[name] = id;
        return acc;
      }, {});

      setmodbusConfigMap(modbusConfigMap);

      // Auto-select the first configuration when available
      if (attrMap.modbus_configs?.length > 0 && !selectedModbusConfigId) {
        const firstConfigId = attrMap.modbus_configs[0]?.id;
        if (firstConfigId) {
          setSelectedModbusConfigId(firstConfigId);
        }
      }

      const interfaceIdMap = attrMap.interfaces.reduce((acc, i) => {
        const id = i.interface || '';
        const name = i.name || '';
        acc[name] = id;
        return acc;
      }, {});

      const interfaceNumberMap = attrMap.interfaces.reduce((acc, i) => {
        const id = i.id || '';
        const num = i.settings.interface;
        acc[id] = num;
        return acc;
      }, {});

      setInterfaceIdMap(interfaceIdMap);
      setInterfaceNumberMap(interfaceNumberMap);
    } catch (err) {
      console.error('Failed to fetch configurations', err);
    } finally {
      setLoading(false);
    }
  }, [deviceId, selectedModbusConfigId]);

  useEffect(() => {
    fetchInterfaces();
  }, [fetchInterfaces]);

  // Auto-select first configuration when modbusConfigMap is populated
  useEffect(() => {
    if (Object.keys(modbusConfigMap).length > 0 && !selectedModbusConfigId) {
      const firstConfigName = Object.keys(modbusConfigMap)[0];
      const firstConfigId = modbusConfigMap[firstConfigName];
      if (firstConfigId) {
        setSelectedModbusConfigId(firstConfigId);
      }
    }
  }, [modbusConfigMap, selectedModbusConfigId]);

  const addSlave = () => {
    // Check against max_modbus_slave
    if (configurations.length >= Number(maxSlavePerDevice)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlavePerDevice} slaves.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    if (deviceType === 1 && configurations.length >= maxSlavePerDevice) {
      showError(
        `You cannot add more than ${maxSlavePerDevice} slaves for device type 1.`,
      );
      return;
    }

    if (deviceType === 2) {
      const interfaceCounts = configurations.reduce((acc, slave) => {
        acc[slave.interface] = (acc[slave.interface] || 0) + 1;
        return acc;
      }, {});

      const canAdd = Object.values(interfaceCounts).every(
        (count) => count < maxSlavePerInterFace,
      );

      if (!canAdd) {
        showError(
          `Each interface can only have ${maxSlavePerInterFace} slaves for device type 2.`,
        );
        return;
      }
    }

    // Duplicate slave name check (case-insensitive, trimmed)
    const trimmedNames = configurations
      .map((s) => (s.name || '').trim().toLowerCase())
      .filter((n) => n); // ignore empty names
    // No need to check for '' here, allow empty name for new slave
    // (block on update if needed)

    const newSlave = {
      id: uuidv4(),
      name: '',
      slaveid: '',
      slaveip: '',
      interface: interfaceIdMap[0],
      parameters: [],
    };

    setConfigurations((prev) => [...prev, newSlave]);
    setOriginalData((prev) => ({ ...prev, [newSlave.id]: newSlave }));
  };

  const updateSlave = (id, field, value) => {
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === id
          ? {
              ...slave,
              [field]: value,
            }
          : slave,
      ),
    );
  };

  const addParameter = (slaveId) => {
    const targetSlave = configurations.find((s) => s.id === slaveId);
    if (!targetSlave) return;

    // Check against max_modbus_params_per_slave
    if (targetSlave.parameters.length >= Number(maxSlaveParameters)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlaveParameters} parameters per slave.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    // if (defaultParameter.name.length > 8) {
    //   toast({
    //     title: 'Parameter Name Too Long',
    //     description: 'Parameter name should not exceed 8 characters.',
    //     status: 'error',
    //     duration: 3000,
    //     position: 'top',
    //     isClosable: true,
    //   });
    //   return;
    // }

    // Check for duplicate parameter name (exact match, case-insensitive, trimmed, non-empty, only within this slave)
    if (
      defaultParameter.name &&
      targetSlave.parameters.some(
        (param) =>
          param.name &&
          param.name.trim().toLowerCase() ===
            defaultParameter.name.trim().toLowerCase(),
      )
    ) {
      toast({
        title: 'Duplicate Parameter Name',
        description: 'Parameter name must be unique within a slave.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    const param = { ...defaultParameter, id: uuidv4() };
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === slaveId
          ? { ...slave, parameters: [...slave.parameters, param] }
          : slave,
      ),
    );

    // Go to last page after adding parameter
    setParamPages((prev) => {
      const newParamCount = (targetSlave.parameters.length || 0) + 1;
      const lastPage = Math.floor((newParamCount - 1) / 10);
      return { ...prev, [slaveId]: lastPage };
    });
  };

  const updateParameter = (slaveId, paramId, field, value) => {
    // Only check for name length, not duplicates
    // if (field === 'name' && value.length > 8) {
    //   toast({
    //     title: 'Parameter Name Too Long',
    //     description: 'Parameter name should not exceed 8 characters.',
    //     status: 'error',
    //     duration: 3000,
    //     position: 'top',
    //     isClosable: true,
    //   });
    //   return;
    // }
    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id !== slaveId) return slave;
        return {
          ...slave,
          parameters: slave.parameters.map((param) =>
            param.id === paramId ? { ...param, [field]: value } : param,
          ),
        };
      }),
    );
  };

  const [deleteTarget, setDeleteTarget] = useState({
    type: null, //
    slaveId: null,
    paramId: null,
  });
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  // const cancelRef = useRef();

  const handleSave = (slave) => {
    // Duplicate slave name check (case-insensitive, trimmed, non-empty, excluding self)
    const trimmedSlaveName = (slave.name || '').trim().toLowerCase();
    if (
      trimmedSlaveName &&
      configurations.some(
        (s) =>
          s.id !== slave.id &&
          s.name &&
          s.name.trim().toLowerCase() === trimmedSlaveName,
      )
    ) {
      // Find all duplicate slave names
      const duplicateNames = configurations
        .filter(
          (s) =>
            s.id !== slave.id &&
            s.name &&
            s.name.trim().toLowerCase() === trimmedSlaveName,
        )
        .map((s) => s.name)
        .join(', ');
      toast({
        title: 'Duplicate Slave Name',
        description: `Slave name must be unique. Duplicate: ${slave.name}${
          duplicateNames ? ` (also: ${duplicateNames})` : ''
        }`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    // Duplicate parameter name check (case-insensitive, trimmed, non-empty, within this slave)
    const paramNames = new Set();
    let duplicateParamName = '';
    for (const param of slave.parameters || []) {
      const trimmedParamName = (param.name || '').trim().toLowerCase();
      if (trimmedParamName) {
        if (paramNames.has(trimmedParamName)) {
          duplicateParamName = param.name;
          break;
        }
        paramNames.add(trimmedParamName);
      }
    }
    if (duplicateParamName) {
      // Find all duplicate parameter names in this slave
      const nameCounts = {};
      (slave.parameters || []).forEach((param) => {
        const key = (param.name || '').trim().toLowerCase();
        if (key) nameCounts[key] = (nameCounts[key] || 0) + 1;
      });
      const duplicates = Object.entries(nameCounts)
        .filter(([_, count]) => count > 1)
        .map(([name]) => name)
        .join(', ');
      toast({
        title: 'Duplicate Parameter Name',
        description: `Parameter names must be unique within a slave. Duplicate: ${duplicates}`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    setConfigurations((prev) => {
      // Find the index of the existing slave
      const index = prev.findIndex((s) => s.id === slave.id);

      let newVersion;

      if (index === -1) {
        // This is a NEW slave
        // Find the maximum version among all existing slaves
        const versions = prev.map((s) => s.version || 1);
        const maxVersion = versions.length ? Math.max(...versions) : 0;
        newVersion = maxVersion + 1;
      } else {
        // This is an EXISTING slave
        const existingSlave = prev[index];
        const original = originalData[slave.id];

        if (original && JSON.stringify(slave) !== JSON.stringify(original)) {
          // Slave has CHANGED - increment its version (current version + 1)
          newVersion = (existingSlave.version || 1) + 1;
        } else {
          // No change - keep the same version
          newVersion = existingSlave.version || 1;
        }
      }

      const updatedSlave = {
        ...slave,
        version: newVersion,
      };

      toast({
        title: 'Slave Saved.',
        description: `Slave ${
          slave.name || slave.id
        } added to the device configuration.`,
        status: 'success',
        duration: 2000,
        position: 'top',
        isClosable: true,
      });

      // Update original data with the saved version
      setOriginalData((prevOriginal) => ({
        ...prevOriginal,
        [slave.id]: JSON.parse(JSON.stringify(updatedSlave)),
      }));

      // Update the configurations array
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = updatedSlave;
        return updated;
      } else {
        return [...prev, updatedSlave];
      }
    });
  };

  const handleSaveConfigurations = async () => {
    try {
      // Step 1: Fetch the current modbus_config to get existing versions
      let existingSlaveVersions = {};
      let serverMaxVersion = 0;

      try {
        const resp = await axiosInstance.get(
          apiUrls.toolDeviceAttributes(
            deviceId,
            'modbus_config,modbus_config_v',
          ),
        );
        const attrMap = Object.fromEntries(
          resp.data.map((a) => [a.key, a.value]),
        );
        const modbusConfig = attrMap['modbus_config'];

        if (modbusConfig?.slave_list?.length) {
          modbusConfig.slave_list.forEach((slave) => {
            if (slave.uuid) {
              existingSlaveVersions[slave.uuid] = slave.version || 1;
              serverMaxVersion = Math.max(serverMaxVersion, slave.version || 1);
            }
          });
        }
      } catch (err) {
        console.error('Error fetching modbus_config for versioning', err);
      }

      // Step 2: Calculate versions for all slaves
      const slavesConfigWithVersions = configurations.map((slave) => {
        const isNew = !existingSlaveVersions.hasOwnProperty(slave.id);
        const original = originalData[slave.id];
        const isChanged = original
          ? JSON.stringify(slave) !== JSON.stringify(original)
          : true;

        let version;

        if (slave.version && !isNew) {
          version = slave.version;
        } else if (isNew) {
          const allCurrentVersions = configurations
            .filter((s) => !isNew || s.id !== slave.id)
            .map((s) => s.version || 1);
          const maxCurrentVersion = Math.max(
            ...allCurrentVersions,
            serverMaxVersion,
            0,
          );
          version = maxCurrentVersion + 1;
        } else if (isChanged) {
          version = (existingSlaveVersions[slave.id] || 1) + 1;
        } else {
          version = existingSlaveVersions[slave.id] || 1;
        }

        // Clean parameters based on GRIDX_TYPE
        const cleanedParameters = slave.parameters.map((param) => {
          const { id, ...restWithoutId } = param;

          if (gridxType === '2') {
            // For GRIDX, send as 'action' field
            const { access, ...rest } = restWithoutId;
            console.log(
              `[cleanedParameters] gridxType=2, param.name=${param.name}, setting action=${access || 0}`,
            );
            return {
              ...rest,
              action: access || 0, // Map access to action
            };
          } else {
            // For other types, send as 'access' field
            const { action, ...rest } = restWithoutId;
            console.log(
              `[cleanedParameters] gridxType!=2, param.name=${param.name}, setting access=${param.access || 0}`,
            );
            return {
              ...rest,
              access: param.access || 0, // Keep as access
            };
          }
        });

        const interfaceName = getInterfaceNameById(slave.interface_id);
        const isModbusTCP = interfaceName === 'Modbus_TCP';

        let slavePayload = {
          interface_id: slave?.interface_id,
          id: slave?.id || '',
          version,
          slave_id: slave?.slaveid || '',
          slave_name: slave?.name || '',
          parameters: cleanedParameters,
        };

        if (isModbusTCP) {
          let slave_ip =
            slave.slaveip !== undefined ? String(slave.slaveip) : '';
          slavePayload.slave_ip = slave_ip;
        }

        return slavePayload;
      });

      // Step 3: Prepare the payload
      const modbusConfigPayload = {
        addConfigToDevice: 1,
        config_id: configId,
        config_name: configName,
        slaves_config: slavesConfigWithVersions,
      };

      // Step 4: Send to server for each selected device
      const checkedDeviceIds = devicesArray
        .filter((d) => selectedDevices.includes(d.id))
        .map((d) => d.name);

      let allDeviceIds = checkedDeviceIds.includes(deviceId)
        ? checkedDeviceIds
        : [...checkedDeviceIds, deviceId];

      allDeviceIds = Array.from(new Set(allDeviceIds.filter(Boolean)));
      for (const deviceId of allDeviceIds) {
        try {
          const response = await axiosInstance.post(
            apiUrls.updateDeviceModbus(deviceId),
            modbusConfigPayload,
          );

          if (response.status === 200) {
            const updatedOriginals = {};
            configurations.forEach((slave) => {
              updatedOriginals[slave.id] = JSON.parse(JSON.stringify(slave));
            });

            setOriginalData(updatedOriginals);

            toast({
              title: `Configuration Saved for Device`,
              description:
                response.data.success || 'Configuration saved successfully',
              status: 'success',
              duration: 3000,
              position: 'top',
              isClosable: true,
            });
            fetchModbusConfigswithDevices();
          } else {
            throw new Error('Unexpected response status');
          }
        } catch (err) {
          console.error(`Error saving config for device ${deviceId}:`, err);

          if (
            err.response?.status === 409 ||
            err.response?.data?.error?.includes('version')
          ) {
            toast({
              title: 'Version Conflict',
              description:
                'Configuration has been modified by another user. Please refresh and try again.',
              status: 'error',
              position: 'top',
              duration: 5000,
              isClosable: true,
            });

            fetchModbusConfigurations();
          } else {
            toast({
              title: 'Error',
              description:
                err.response?.data?.error || 'Unknown error occurred',
              status: 'error',
              position: 'top',
              duration: 3000,
              isClosable: true,
            });
          }
        }
      }

      onCloseSaveConf();
      await fetchModbusConfigurations();
    } catch (err) {
      console.error('Save failed:', err);
      toast({
        title: 'Save Failed',
        description: 'Could not save the configurations. Please try again.',
        status: 'error',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const fetchModbusData = useCallback(async () => {
    try {
      const resp = await axiosInstance.get(
        apiUrls.getModbusData(selectedModbusConfigId),
      );

      const attrMap = Object.fromEntries(
        resp.data.map((a) => [a.key, a.value]),
      );
      const modbusConfig = attrMap['modbus_config'];

      if (attrMap['config_device_type']) {
        setGridxType(attrMap['config_device_type']);
      }

      setConfigName(modbusConfig?.name || '');
      setConfigId(modbusConfig?.id || '');

      if (!modbusConfig?.slave_list?.length) {
        console.warn('No slave_list found.');
        return;
      }

      const deviceType = attrMap['config_device_type']
        ? Number(attrMap['config_device_type'])
        : 1;

      const mergedConfigurations = modbusConfig.slave_list.map((slave) => {
        const config = slave.config || {};
        const meta = attrMap[slave.uuid] || {};

        return {
          id: slave.uuid,
          name: meta.name || '',
          slaveid: config.slaveid || '',
          slaveip: config.slaveip || '',
          interface_id: config.interface_id ?? 0,
          method: config.method?.toLowerCase() || '',
          port: config.port || '',
          baudrate: config.baudrate || 9600,
          timeout: config.timeout || 1000,
          parity: config.parity || 'N',
          stopbit: config.stopbit || 1,
          bytesize: config.bytesize || 8,
          pollperiod: config.pollperiod || 1000,
          host: config.host || '',
          parameters: (meta.parameters || []).map((param) => {
            const mappedParam = { ...param, id: param.id || uuidv4() };

            if (deviceType === 2) {
              mappedParam.access =
                param.action !== undefined ? param.action : 0;
            } else {
              mappedParam.access =
                param.access !== undefined ? param.access : 0;
            }

            return mappedParam;
          }),
          model: '',
          make: '',
          type: '',
          protocol: '',
          version: slave.version,
        };
      });

      setConfigurations(mergedConfigurations);
      setOriginalData(() => {
        const data = {};
        mergedConfigurations.forEach((slave) => {
          data[slave.id] = JSON.parse(JSON.stringify(slave));
        });
        return data;
      });
    } catch (err) {
      console.error('Error loading configuration:', err);
    }
  }, [selectedModbusConfigId]);

  useEffect(() => {
    // Only fetch if selectedModbusConfigId is valid (exists in modbusConfigMap)
    if (
      selectedModbusConfigId &&
      Object.values(modbusConfigMap).includes(selectedModbusConfigId)
    ) {
      fetchModbusData();
    }
  }, [selectedModbusConfigId, modbusConfigMap, fetchModbusData]);
  const fetchDeviceInterfaces = useCallback(async () => {
    let keys = [
      'app_version',
      'device_type',
      'patch_v',
      'max_modbus_slave',
      'max_slave_per_interface',
      'max_modbus_params_per_slave',
      'rs485_1',
      'rs485_2',
      'rs485_3',
      'tcp',
    ];
    keys = keys.join(',');
    try {
      const resp = await axiosInstance.get(
        apiUrls.toolDeviceAttributes(deviceId, keys),
      );
      // console.log('tool data------->', JSON.stringify(resp));

      const attrs = resp.data;
      const attrMap = Object.fromEntries(attrs.map((a) => [a.key, a.value]));

      setDeviceType(attrMap.device_type || 1);
      setMaxSlavePerDevice(attrMap.max_modbus_slave || 1);
      setMaxSlavePerInterFace(attrMap.max_slave_per_interface || 1);
      setMaxSlaveParameters(attrMap.max_modbus_params_per_slave || 5);
    } catch (err) {
      console.error('Error fetching attributes', err);
    } finally {
      setLoading(false);
    }
  }, [deviceId]); // add deviceId as dependency

  const handleCheckboxChange = (id) => {
    setSelectedDevices((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id],
    );
  };

  const fetchModbusConfigurations = useCallback(async () => {
    if (!deviceId) return;

    try {
      // Step 1: Fetch modbus_config
      const resp = await axiosInstance.get(
        apiUrls.toolDeviceAttributes(deviceId, 'modbus_config,modbus_config_v'),
      );

      const attrMap = Object.fromEntries(
        resp.data.map((a) => [a.key, a.value]),
      );
      const modbusConfig = attrMap['modbus_config'];

      setConfigName(modbusConfig?.name || '');
      setConfigId(modbusConfig?.id || '');

      if (modbusConfig?.id) {
        setSelectedModbusConfigId(modbusConfig.id);
        localStorage.setItem('selectedModbusConfigId', modbusConfig.id);
      }

      if (!modbusConfig?.slave_list?.length) {
        console.warn('No slave_list found.');
        return;
      }

      // Step 2: Extract slave UUIDs
      const slaveUUIDs = modbusConfig.slave_list.map((s) => s.uuid).join(',');

      // Step 3: Fetch metadata for all slaves
      const metaResp = await axiosInstance.get(
        apiUrls.toolDeviceAttributes(deviceId, slaveUUIDs),
      );
      const metaMap = Object.fromEntries(
        metaResp.data.map((a) => [a.key, a.value]),
      );

      // Step 4: Merge configs
      const mergedConfigurations = modbusConfig.slave_list.map((slave) => {
        const config = slave.config || {};
        const meta = metaMap[slave.uuid] || {};

        return {
          id: slave.uuid,
          name: meta.name || '',
          slaveid: config.slaveid || '',
          slaveip: config.slaveip || '',
          interface_id: config.interface_id ?? 0,
          method: config.method?.toLowerCase() || '',
          port: config.port || '',
          baudrate: config.baudrate || 9600,
          timeout: config.timeout || 1000,
          parity: config.parity || 'N',
          stopbit: config.stopbit || 1,
          bytesize: config.bytesize || 8,
          pollperiod: config.pollperiod || 1000,
          host: config.host || '',
          parameters: (meta.parameters || []).map((param) => ({
            ...param,
            id: param.id || uuidv4(), // Assign ID if missing
          })),
          model: '',
          make: '',
          type: '',
          protocol: '',
          version: slave.version,
        };
      });

      setConfigurations(mergedConfigurations);
      setOriginalData(() => {
        const data = {};
        mergedConfigurations.forEach((slave) => {
          data[slave.id] = JSON.parse(JSON.stringify(slave));
        });
        return data;
      });
    } catch (err) {
      console.error('Error loading configuration:', err);
    }
  }, [deviceId]);

  useEffect(() => {
    fetchModbusConfigurations();
  }, [fetchModbusConfigurations]);

  useEffect(() => {
    fetchDeviceInterfaces();
  }, [fetchDeviceInterfaces]);

  const updateSlaveParams = (parameters) => {
    if (!currentSlaveId || !parameters || !Array.isArray(parameters)) {
      console.error('Invalid parameters or no slave selected');
      return;
    }

    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id === currentSlaveId) {
          const newParameters = parameters.map((param) => ({
            id: param.id || uuidv4(),
            name: param.name || '',
            fn_code: param.fnCode || 3,
            address: param.address || 0,
            type: ParamTypes[param.type] || 43,
            factor: param.factor || 1,
            register_count: param.regCount || 1,
            register_data_type: RegisterDataType[param.regDataType] || 1,
            offset: param.offset || 0,
            write_fn_code: writeFunctionCodes[param.writeFn] || -1,
            access: Actions[param.access] || 0,
          }));

          return {
            ...slave,
            parameters: [...slave.parameters, ...newParameters],
          };
        }
        return slave;
      }),
    );
  };
  const addBulkParameters = () => {
    // Find the next available slaveid starting from 3
    const existingSlaveIds = configurations
      .map((s) => Number(s.slaveid))
      .filter((n) => !isNaN(n));
    let nextSlaveId = 3;
    const slavesToAdd = [];
    const interfaceId = Object.values(interfaceIdMap)[3] || 0;

    for (let i = 0; i < 31; i++) {
      // Find the next unused slaveid
      while (existingSlaveIds.includes(nextSlaveId)) {
        nextSlaveId++;
      }
      const slaveName = `test-slave${nextSlaveId}`;
      const newSlaveId = uuidv4();
      const bulkParams = Array.from({ length: 1000 }, (_, j) => ({
        ...defaultParameter,
        id: uuidv4(),
        name: `${slaveName}_temp_${j + 1}`,
        address: j + 1,
        register_count: 2,
        register_data_type: 1,
        offset: 0,
        write_fn_code: -1,
        action: 0,
      }));
      slavesToAdd.push({
        id: newSlaveId,
        name: slaveName,
        slaveid: nextSlaveId,
        slaveip: '',
        interface: interfaceId,
        interface_id: interfaceId,
        parameters: bulkParams,
      });
      existingSlaveIds.push(nextSlaveId);
      nextSlaveId++;
    }

    setConfigurations((prev) => [...prev, ...slavesToAdd]);
    setOriginalData((prev) => {
      const updated = { ...prev };
      slavesToAdd.forEach((slave) => {
        updated[slave.id] = slave;
      });
      return updated;
    });
  };

  const showAllColumns = String(gridxType) === '2';
  const [expandedSlaves, setExpandedSlaves] = useState({});

  const toggleSlaveExpand = (slaveId) => {
    setExpandedSlaves((prev) => ({
      ...prev,
      [slaveId]: !prev[slaveId],
    }));
  };

  // Pagination state: track current page per slave
  const [paramPages, setParamPages] = useState({});

  // Helper: get paginated parameters for a slave
  const getPaginatedParameters = (slave) => {
    const page = paramPages[slave.id] || 0;
    const pageSize = 10;
    const start = page * pageSize;
    const end = start + pageSize;
    return slave.parameters.slice(start, end);
  };

  // Helper: total pages for a slave
  const getTotalPages = (slave) => {
    return Math.ceil((slave.parameters?.length || 0) / 10);
  };

  // Handler: change page for a slave
  const handleParamPageChange = (slaveId, newPage) => {
    setParamPages((prev) => ({
      ...prev,
      [slaveId]: newPage,
    }));
  };
  useEffect(() => {
    if (configurations.length > 0) {
      const allExpanded = {};
      configurations.forEach((slave) => {
        allExpanded[slave.id] = true;
      });
      setExpandedSlaves(allExpanded);
    }
  }, [configurations]);

  // When user changes config, update state and localStorage
  const handleModbusConfigChange = (selectedConfig) => {
    setSelectedModbusConfigId(selectedConfig);
    localStorage.setItem('selectedModbusConfigId', selectedConfig);
  };

  // On mount, if localStorage has a value and it's valid, use it
  useEffect(() => {
    const storedConfigId = localStorage.getItem('selectedModbusConfigId');
    if (
      storedConfigId &&
      Object.values(modbusConfigMap).includes(storedConfigId)
    ) {
      setSelectedModbusConfigId(storedConfigId);
    }
  }, [Object.keys(modbusConfigMap).length]);

  useEffect(() => {
    if (Object.keys(modbusConfigMap).length > 0 && !selectedModbusConfigId) {
      const firstConfigId = Object.values(modbusConfigMap)[0];
      if (firstConfigId) {
        setSelectedModbusConfigId(firstConfigId);
        localStorage.setItem('selectedModbusConfigId', firstConfigId);
      }
    }
  }, [modbusConfigMap, selectedModbusConfigId]);

  // Helper to get interface name by interface_id
  const getInterfaceNameById = (interface_id) => {
    const iface = interfaceList.find((i) => i.interface === interface_id);
    return iface ? iface.name : '';
  };

  const getInterfaceSettingsById = (interface_id) => {
    return interfaceSettingsMap[interface_id] || {};
  };

  const getDevicesByAssetName = async (assetName) => {
    console.log('getDevicesByAssetName called with:', assetName);

    const assetResp = await axiosInstance.get(apiUrls.assetResp(assetName));
    const assetId = assetResp.data.data[0]?.id?.id;

    if (!assetId) return [];

    const relationResp = await axiosInstance.get(apiUrls.relationResp(assetId));

    const devices = relationResp.data
      .filter((r) => r.to.entityType === 'DEVICE')
      .map((r) => ({
        deviceId: r.to.id,
        name: r.toName,
      }));

    return devices;
  };

  const fetchCountries = async () => {
    try {
      const resp = await axiosInstance.get(apiUrls.getCountries());
      const options = (resp.data?.data || []).map((item) => ({
        label: item.name,
        value: item.id.id,
      }));
      setClusterOptions(options);
    } catch {
      setClusterOptions([]);
    }
  };
  const fetchStates = async (countryId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(countryId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setStateOptions(options);
    } catch {
      setStateOptions([]);
    }
  };
  const fetchNocs = async (stateId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(stateId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setNocOptions(options);
    } catch {
      setNocOptions([]);
    }
  };
  const fetchPlants = async (nocId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(nocId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setPlantOptions(options);
    } catch {
      setPlantOptions([]);
    }
  };

  const fetchClusterDevices = async (id) => {
    setLoadingDevices(true);
    try {
      const token = Cookies.get('authToken');
      const resp = await fetch(apiUrls.getClusterDevices(id), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (!resp.ok) throw new Error('Network response was not ok');
      const data = await resp.json();
      console.log('Cluster devices response:', data);

      const devicesNameIdMap = (data?.devices || []).map((d) => ({
        id: String(d.id), // UUID
        name: d.name, // Device name
      }));
      setDevicesArray(devicesNameIdMap);
      const preselected = devicesNameIdMap
        .filter(
          (d) =>
            preselectedDevices.includes(d.id) ||
            preselectedDevices.includes(d.name),
        )
        .map((d) => d.id);

      setSelectedDevices(Array.from(new Set([...preselected, deviceId])));
    } catch (err) {
      setDevicesArray([]);
      setSelectedDevices([]);
      console.error('Failed to fetch cluster devices:', err);
    } finally {
      setLoadingDevices(false);
    }
  };

  useEffect(() => {
    if (selectedCluster) {
      fetchStates(selectedCluster);
      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedCluster); // Only this call
    }
  }, [selectedCluster]);
  useEffect(() => {
    if (selectedState) {
      fetchNocs(selectedState);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedState); // Only this call
    }
  }, [selectedState]);
  useEffect(() => {
    if (selectedNoc) {
      fetchPlants(selectedNoc);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedNoc); // Only this call
    }
  }, [selectedNoc]);
  useEffect(() => {
    if (selectedPlant) {
      setLoadingDevices(true);
      fetchClusterDevices(selectedPlant);
    }
  }, [selectedPlant]);
  useEffect(() => {
    if (searchType === 'cluster') {
      fetchCountries();
      setSelectedDevices(
        preselectedDevices.length > 0
          ? Array.from(new Set([...preselectedDevices, deviceId]))
          : [deviceId],
      );
      setSelectedCluster('');
      setStateOptions([]);
      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      // setDevicesArray([]);
    }
  }, [searchType]);
  useEffect(() => {
    if (searchType === 'deviceId') {
      setSelectedDevices(
        Array.from(new Set([...preselectedDevices, deviceId])),
      );
    }
  }, [searchType, preselectedDevices]);

  return (
    <>
      {loading ? (
        <TableSkeleton rowCount={5} columnCount={12} />
      ) : (
        <Box color={textColor}>
          <Flex justify="space-between" mt={1} align="center">
            <Heading size="lg" mb={6}>
              Slave Configurations
            </Heading>

            {/* Group interface select + buttons on the right */}
            <Flex align="center">
              {Object.keys(modbusConfigMap).length > 0 && (
                <Box mr={3}>
                  <Flex>
                    <Text me="3" mt={1} fontWeight="600">
                      Config:
                    </Text>
                    <InterfaceSelect
                      value={
                        selectedModbusConfigId ||
                        Object.values(modbusConfigMap)[0]
                      }
                      options={modbusConfigMap}
                      onChange={handleModbusConfigChange}
                      disabled={!isTenantAdmin}
                    />
                  </Flex>
                </Box>
              )}

              {/* Buttons grouped together with no gap */}
              <Flex align="center">
                {/* <Button
                  size="sm"
                  colorScheme="green"
                  variant="outline"
                  border="2px"
                  cursor="pointer"
                  onClick={() => {
                    // navigate to the same EditDevice route and request tab index 2 (Add Configuration)
                    navigate(location.pathname, { state: { activeTab: 2 } });
                  }}
                >
                  Add More Configuration
                </Button> */}
                {isTenantAdmin && (
                  <Button
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={() => {
                      onOpenSaveConf();
                      setCurrentPage(0);
                      setDevicesArray([]);
                      setSearchType('deviceId');
                    }}
                    ml={1} // very small space (4px) between the two buttons
                  >
                    Save Configuration
                  </Button>
                )}
              </Flex>
            </Flex>
          </Flex>
          {configurations.map((slave) => {
            const interfaceName = getInterfaceNameById(slave.interface_id);
            const isModbusTCP = interfaceName === 'Modbus_TCP';
            // const defaultPort =
            //   slave.port !== undefined && slave.port !== '' ? slave.port : 502;
            return (
              <Card key={slave.id} bg={cardBg} p={4} my={4} color={textColor}>
                {/* Slave Info Table */}
                <Table size="sm" mb={4}>
                  <Thead>
                    <Tr>
                      <Th textAlign="center" borderColor="transparent">
                        Name
                      </Th>
                      {isModbusTCP && (
                        <Th textAlign="center" borderColor="transparent">
                          Slave IP
                        </Th>
                      )}
                      <Th textAlign="center" borderColor="transparent">
                        Slave ID
                      </Th>
                      <Th textAlign="center" borderColor="transparent">
                        Interface
                      </Th>
                      <Th borderColor="transparent" textAlign="center" />
                      <Th borderColor="transparent" textAlign="center" />
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td textAlign="center" borderColor="transparent" ps={0}>
                        {slave.name}
                      </Td>
                      {isModbusTCP && (
                        <Td textAlign="center" borderColor="transparent" ps={0}>
                          {slave.slaveip}
                        </Td>
                      )}
                      <Td textAlign="center" borderColor="transparent" ps={0}>
                        {slave.slaveid}
                      </Td>
                      <Td textAlign="center" borderColor="transparent" ps={0}>
                        {getInterfaceNameById(slave.interface_id)}
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
                <HSeparator />
                <ComplexTable
                  tableData={slave.parameters.map((param) => {
                    const data = (v) =>
                      v === undefined || v === null || v === '' ? '-' : v;

                    return {
                      ...param,
                      name: data(param.name),
                      fn_code: data(param.fn_code),
                      address: data(param.address),
                      type: data(ParamTypesReverse[param.type] || param.type),
                      factor: data(param.factor),
                      register_count: data(param.register_count),
                      register_data_type: data(
                        RegisterDataTypeReverse[param.register_data_type] ||
                          param.register_data_type,
                      ),
                      offset: data(param.offset),
                      write_fn_code: data(
                        writeFunctionCodesReverse[param.write_fn_code] ||
                          param.write_fn_code,
                      ),
                      access: data(
                        ActionsReverse[
                          param.access !== undefined
                            ? param.access
                            : param.action
                        ] ||
                          (param.access !== undefined
                            ? param.access
                            : param.action),
                      ),
                      thresholds:
                        Array.isArray(param.thresholds) &&
                        param.thresholds.length > 0 &&
                        param.thresholds.some(
                          (t) =>
                            (t.min !== undefined &&
                              t.min !== null &&
                              t.min !== '') ||
                            (t.max !== undefined &&
                              t.max !== null &&
                              t.max !== ''),
                        )
                          ? param.thresholds
                              .map((t) =>
                                (t.min !== undefined &&
                                  t.min !== null &&
                                  t.min !== '') ||
                                (t.max !== undefined &&
                                  t.max !== null &&
                                  t.max !== '')
                                  ? `min: ${data(t.min)}, max: ${data(t.max)}`
                                  : '-',
                              )
                              .join(' | ')
                          : '-',
                    };
                  })}
                  columnsData={[
                    {
                      header: 'Name',
                      accessorKey: 'name',
                    },
                    {
                      header: 'Fn Code',
                      accessorKey: 'fn_code',
                    },
                    {
                      header: 'Address',
                      accessorKey: 'address',
                    },
                    {
                      header: 'Type',
                      accessorKey: 'type',
                    },
                    {
                      header: 'Factor',
                      accessorKey: 'factor',
                    },

                    ...(showAllColumns
                      ? [
                          {
                            header: 'Reg Count',
                            accessorKey: 'register_count',
                          },
                          {
                            header: 'Register Data Type',
                            accessorKey: 'register_data_type',
                          },
                          {
                            header: 'Offset',
                            accessorKey: 'offset',
                          },
                          {
                            header: 'Write Fn',
                            accessorKey: 'write_fn_code',
                          },
                        ]
                      : []),
                    {
                      header: 'Thresholds',
                      accessorKey: 'thresholds',
                    },
                    {
                      header: 'Access',
                      accessorKey: 'access',
                    },
                  ]}
                  loading={false}
                  pageSize={10}
                  enableLocalPagination={true}
                  totalPages={getTotalPages(slave)}
                  hasNext={
                    (paramPages[slave.id] || 0) < getTotalPages(slave) - 1
                  }
                  title="Parameters"
                />
                <AssetParamDialog
                  open={openAssetMastermodel}
                  onClose={closeAssetParameterModal}
                  updateSlaveParams={updateSlaveParams}
                />
                {/* <HSeparator /> */}
              </Card>
            );
          })}

          <AssetParamDialog
            open={open}
            onClose={() => {
              setOpen(false);
              setCurrentSlaveId(null);
            }}
            updateSlaveParams={updateSlaveParams}
          />

          {/* <Flex justify="center" mt={6}>
            <Button
              size="sm"
              mx="2"
              variant="outline"
              border="2px"
              colorScheme="orange"
              cursor="pointer"
              onClick={addSlave}
            >
              Add Slave
            </Button>
          </Flex> */}

          {/* Replace Delete AlertDialog */}
          <GlobalAlertDialog
            isOpen={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            onConfirm={handleDeleteConfirmed}
            title={
              deleteTarget.type === 'slave'
                ? 'Delete Slave'
                : 'Delete Parameter'
            }
            body={
              <>
                Are you sure you want to delete this{' '}
                {deleteTarget.type === 'slave' ? 'slave' : 'parameter'}? This
                action cannot be undone.
              </>
            }
            confirmText="Delete"
            cancelText="Cancel"
            showCancel={true}
          />

          {/* Replace Error AlertDialog */}
          <GlobalAlertDialog
            isOpen={isErrorOpen}
            onClose={() => setIsErrorOpen(false)}
            onConfirm={() => setIsErrorOpen(false)}
            title="Validation Error"
            body={errorMessage}
            confirmText="OK"
            showCancel={false}
          />
          <ClusterModal
            isOpen={isOpenSaveConf}
            onClose={() => {
              onCloseSaveConf();
              setCurrentPage(-1);
            }}
            title={`Save Configurations : ${deviceId}`}
            mainInputLabel="Config Name"
            mainInputValue={configName}
            onMainInputChange={(e) => setConfigName(e.target.value)}
            searchType={searchType}
            onSearchTypeChange={setSearchType}
            serialNumber={serialNumber}
            onSerialNumberChange={(e) => setSerialNumber(e.target.value)}
            onSerialNumberSearch={async (e) => {
              if (e.key === 'Enter') {
                fetchAllDevices(e.target.value, true, 0);
              }
            }}
            clusterOptions={clusterOptions}
            selectedCluster={selectedCluster}
            onClusterChange={setSelectedCluster}
            stateOptions={stateOptions}
            selectedState={selectedState}
            onStateChange={setSelectedState}
            nocOptions={nocOptions}
            selectedNoc={selectedNoc}
            onNocChange={setSelectedNoc}
            plantOptions={plantOptions}
            selectedPlant={selectedPlant}
            onPlantChange={setSelectedPlant}
            devicesArray={devicesArray}
            selectedDevices={selectedDevices}
            onDeviceToggle={handleCheckboxChange}
            onSelectAllDevices={(e) => {
              if (e.target.checked) {
                setSelectedDevices([
                  ...selectedDevices.filter((id) =>
                    devicesArray.find(
                      (d) => d.id === id && d.name === deviceId,
                    ),
                  ),
                  ...devicesArray
                    .filter((d) => d.name !== deviceId)
                    .map((d) => d.id),
                ]);
              } else {
                setSelectedDevices(
                  selectedDevices.filter((id) =>
                    devicesArray.find(
                      (d) => d.id === id && d.name === deviceId,
                    ),
                  ),
                );
              }
            }}
            loadingDevices={loadingDevices}
            onLoadMore={() => setCurrentPage((prev) => prev + 1)}
            onSave={handleSaveConfigurations}
            saveDisabled={!configName}
            inputBg={inputBg}
            textColor={textColor}
            footerError={!configName}
            footerErrorText="Config name is required."
            deviceId={deviceId}
            preselectedDevices={preselectedDevices}
            showMainInputDisabled={true}
          />
        </Box>
      )}
    </>
  );
}
